export default __webpack_public_path__ + "static/media/client.1fa82d2e.svg";